export const LOAD_EXPORTED_INVOICES = 'LOAD_EXPORTED_INVOICES'
export const LOAD_EXPORTED_INVOICES_SUCCESS = 'LOAD_EXPORTED_INVOICES_SUCCESS'
export const LOAD_EXPORTED_INVOICES_FAILED = 'LOAD_EXPORTED_INVOICES_FAILED'

export const LOAD_ERRORED_LIST = 'LOAD_ERRORED_LIST'
export const LOAD_ERRORED_LIST_SUCCESS = 'LOAD_ERRORED_LIST_SUCCESS'
export const LOAD_ERRORED_LIST_FAILED = 'LOAD_ERRORED_LIST_FAILED'

export const EXPORT_WORKORDER_INVOICES = 'EXPORT_WORKORDER_INVOICES'
export const EXPORT_WORKORDER_INVOICES_SUCCESS = 'EXPORT_WORKORDER_INVOICES_SUCCESS'
export const EXPORT_WORKORDER_INVOICES_FAILED = 'EXPORT_WORKORDER_INVOICES_FAILED'

export const LOAD_ADMINISTRATIONS = 'LOAD_ADMINISTRATIONS'
export const LOAD_ADMINISTRATIONS_SUCCESS = 'LOAD_ADMINISTRATIONS_SUCCESS'
export const LOAD_ADMINISTRATIONS_FAILED = 'LOAD_ADMINISTRATIONS_FAILED'

export const UPDATE_INVOICE_STATUS = 'UPDATE_INVOICE_STATUS'
export const UPDATE_INVOICE_STATUS_SUCCESS = 'UPDATE_INVOICE_STATUS_SUCCESS'
export const UPDATE_INVOICE_STATUS_FAILED = 'UPDATE_INVOICE_STATUS_FAILED'

export const LOAD_EXAMPLE_BOOKING = 'LOAD_EXAMPLE_BOOKING'
export const LOAD_EXAMPLE_BOOKING_SUCCESS = 'LOAD_EXAMPLE_BOOKING_SUCCESS'
export const LOAD_EXAMPLE_BOOKING_FAILED = 'LOAD_EXAMPLE_BOOKING_FAILED'
